import { create } from "zustand";
import { CSSProperties } from "react";
//--------------------------------------------------------------------------------------------
interface MainStore {
    showLoader: boolean;
    setShowLoader: (value: boolean) => void;
    mainMenuStyle: CSSProperties | null;
    setMainMenuStyle: (value: CSSProperties | null) => void;
    mapFull: boolean;
    setMapFull: (value: boolean) => void;
}

export const useMyStore = create<MainStore>((set) => ({
    // ---- System Loader ----
    showLoader: false,
    setShowLoader: (value) => set({ showLoader: value }),
    // ---- Main style states ----
    mainMenuStyle: null,
    setMainMenuStyle: (value) => set({ mainMenuStyle: value }),
    mapFull: false,
    setMapFull: (value) => set({ mapFull: value }),
}));
